// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"c13be5f9","71":"918e41ae","117":"48284dee","295":"3670d32a","393":"614de976","427":"bd61962d","648":"3605eed2","772":"08010a0b","832":"545829a8","881":"a2df018b","894":"33fca7a8","912":"fccf52fa"}[chunkId] + ".chunk.js";
};